// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"facbecb4","455":"5a8015a0","977":"6f013f3d"}[chunkId] + ".chunk.js";
};